import { Container, EachExperience, EachExperienceContainer, ExperienceContainer, TextContainer, ValueContainer } from "./styles";
import { experience, experienceText, getExperience, totalExperience } from "./constants";
import { useRef, useState } from "react";

export default function Experience() {
    const { years, months, days } = getExperience(totalExperience);
    const [showDetails,setShowDetails]=useState(false);
    const ele=useRef();
    return (
        <Container id="EXPERIENCE">
            <ExperienceContainer onClick={()=>setShowDetails(!showDetails)}>
                <TextContainer>{experienceText}</TextContainer>
                <ValueContainer>{`${years ? years + ' years ' : ''}${months ? months + ' months ' : ''}${days ? days + ' days ' : ''}`}</ValueContainer>
            </ExperienceContainer>
            <EachExperienceContainer ref={ele} eleRef={ele} showdetails={showDetails} boxlength={experience.length}>
                {experience.map((eachExperience,index) => {
                    const { from, to ,company} = eachExperience;
                    const { years, months, days } = getExperience((to ? new Date(to) : new Date(new Date().toDateString())) - (new Date(from)));
                    return (
                        <EachExperience key={index}>
                            <TextContainer>{company}</TextContainer>
                            <ValueContainer>{`${years ? years + ' years ' : ''}${months ? months + ' months ' : ''}${days ? days + ' days ' : ''}`}</ValueContainer>
                        </EachExperience>
                    );
                })}
            </EachExperienceContainer>
        </Container>
    );
}